import React from "react";
import {
  parseRace20Cards,
  race20CardImg,
  RACE20_SUITS,
} from "../../diamondCasinoAllGames/race20/race20Cards";

const BASE = import.meta.env.BASE_URL;
const ICONS = `${BASE}img/cardIcons`;
const WINNER_IMG = `${BASE}img/winner.png`;

/**
 * Race 20 result body — reference markup (index.css `.race-result-box`):
 * .row.row5 > .col-12.col-lg-12 > .race-result-box > 4 suit rows (icon, cards, K[.k-image when 5 cards],
 * trophy on the winning suit) + .video-winner-text; then .casino-result-desc (Winner / Points / Cards
 * from rdesc "winner#points#cards").
 */
export default function Race20ResultBody({ t1 }) {
  const { bySuit } = parseRace20Cards(t1?.card);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      <div className="col-12 col-lg-12">
        <div className="race-result-box">
          {RACE20_SUITS.map((suit, si) => {
            const list = bySuit[suit.key];
            return (
              <React.Fragment key={suit.key}>
                <div className="pr mb-1">
                  <span className="result-image icons">
                    <img src={`${ICONS}/${suit.icon}.png`} alt="" />
                  </span>{" "}
                  {list.map((token, i) => (
                    <span key={i} className="result-image">
                      <img src={race20CardImg(token)} alt="" />
                    </span>
                  ))}{" "}
                  {list.length > 0 && (
                    <span className={`result-image${list.length === 5 ? " k-image" : ""}`}>
                      <img src={race20CardImg(suit.king)} alt="" />
                    </span>
                  )}{" "}
                  {win === String(si + 1) && (
                    <div className="casino-result-cards-item">
                      <img src={WINNER_IMG} className="winner-icon" alt="" />
                    </div>
                  )}
                </div>{" "}
              </React.Fragment>
            );
          })}
          <div className="video-winner-text">
            <div>W</div> <div>I</div> <div>N</div> <div>N</div> <div>E</div> <div>R</div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-12">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Points</div> <div>{desc[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Cards</div> <div>{desc[2]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
